import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

const useCss = makeCss({
  drawerBody: {
    gap: '8px',
    padding: '16px 20px',
  },
});

export const FeatureDrawerContent = ({ children, className }) => {
  const css = useCss();

  return (
    <Drawer.Body css={css.drawerBody} className={className}>
      {children}
    </Drawer.Body>
  );
};

FeatureDrawerContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
